import React, { ChangeEvent, FC, useCallback, useState } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { Form, Input, Modal } from 'src/common';
import { getUpdateCacheOnCreateBids, useCreateBids } from 'src/models/bids/Bids/hooks';
import { useActiveWsIdState } from 'src/models/workspace/hooks';
import { BidItemType } from '@tendium/prom-types/tender';
import { trackCreateManualBid } from 'src/segment/events';

interface IProps {
  onClose: () => void;
}
export const CreateManualBidModal: FC<IProps> = props => {
  const { onClose } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [createManualBid, { loading }] = useCreateBids();
  const [title, setTitle] = useState('');
  const [activeWsId] = useActiveWsIdState();

  const originType = BidItemType.Manual;

  const onCreateManualbid = useCallback(async () => {
    if (!title || !activeWsId || loading) {
      form.setFields([
        {
          name: 'title',
          errors: [t('enterBidTitle')]
        }
      ]);
    } else {
      await createManualBid({
        variables: {
          workspaceId: activeWsId,
          itemType: originType,
          items: [{ name: title }]
        },
        update: getUpdateCacheOnCreateBids([], originType, activeWsId)
      });
      trackCreateManualBid({
        id: activeWsId
      });
      onClose();
    }
  }, [title, activeWsId, loading, form, t, createManualBid, originType, onClose]);

  const onChangeHandler = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  }, []);

  return (
    <Modal
      title={t('BidSpaces.WorkspaceCreateManualBid.createManualBid')}
      visible
      onCancel={onClose}
      onOk={onCreateManualbid}
      okText={t('BidSpaces.WorkspaceCreateManualBid.createBid')}
      okButtonProps={{
        loading: !!loading,
        disabled: !title && !loading,
        className: styles.okButton
      }}
      cancelButtonProps={{
        className: styles.cancelButton
      }}
      className={styles.modal}
      maskClosable={false}
    >
      <Form form={form} onFinish={onCreateManualbid}>
        <div className={styles.unit}>
          <Form.Item
            label={t('BidSpaces.WorkspaceCreateManualBid.titleOfBid')}
            name="title"
            rules={[{ required: true, message: t('BidSpaces.WorkspaceCreateManualBid.titleIsRequiered') }]}
            requiredMark={true}
            className={styles.formItem}
          >
            <Input
              onChange={onChangeHandler}
              name="title"
              type="text"
              maxLength={100}
              placeholder={t('BidSpaces.WorkspaceCreateManualBid.titleOfBid')}
              autoFocus
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};

export default CreateManualBidModal;
